import './styles/App.css';
import './styles/admin/App.css';
import Routes from "./Routes";
import 'bootstrap/dist/css/bootstrap.min.css';
import { UserProvider } from "./context/UserContext.tsx";
import { SportProvider } from "./context/SportContext.tsx";
import { AgentProvider } from './context/admin/Agent.tsx';
import { BetProvider } from './context/BetContext.tsx';
import { ParlayBetProvider } from './context/ParlayBetContext.tsx';

function App() {
  return (

    <UserProvider>
      <AgentProvider>
        <SportProvider>
          <BetProvider>
            <ParlayBetProvider>
              <Routes />
            </ParlayBetProvider>
          </BetProvider>
        </SportProvider>
      </AgentProvider>
    </UserProvider>
  );
}
export default App; 
